export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14226.1f5da7a4.jpg";